var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.79721C19.2642 4.12388 18.4733 4.34388 17.6433 4.44305C18.4908 3.93555 19.1417 3.13138 19.4475 2.17305C18.655 2.64305 17.7767 2.98471 16.8417 3.16888C16.0942 2.37138 15.0267 1.87305 13.8467 1.87305C11.1975 1.87305 9.25083 4.34471 9.84917 6.91055C6.44 6.73971 3.41667 5.10638 1.3925 2.62388C0.3175 4.46805 0.835 6.88055 2.66167 8.10221C1.99 8.08055 1.35667 7.89638 0.804167 7.58888C0.759167 9.48971 2.12167 11.268 4.095 11.6639C3.5175 11.8205 2.885 11.8572 2.24167 11.7339C2.76333 13.3639 4.27833 14.5497 6.075 14.583C4.35 15.9355 2.17667 16.5397 0 16.283C1.81583 17.4472 3.97333 18.1264 6.29 18.1264C13.9083 18.1264 18.2125 11.6922 17.9525 5.92138C18.7542 5.34221 19.45 4.61971 20 3.79721Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.5c1e2b44063e9579ba1809c2408cd5af.svg";
export { ForwardRef as ReactComponent };